import { render, staticRenderFns } from "./GTextArea.vue?vue&type=template&id=039035ce&"
import script from "./GTextArea.vue?vue&type=script&lang=js&"
export * from "./GTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports